import { render } from "./EzerWelcome.vue?vue&type=template&id=cef81648"
import script from "./EzerWelcome.vue?vue&type=script&lang=js"
export * from "./EzerWelcome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__